import React from 'react';
import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import logo from "../assets/splash logo.svg";

const DataDeletion = () => {
    const navigate = useNavigate();

    const handleLinkClick = () => {
        navigate('/');
        window.scrollTo(0, 0);
    };
    
    return (
        <div className="container mx-auto py-8">
            <Helmet>
                <title>Swop | Data Deletion</title>
            </Helmet>
            <Link to={'/'} onClick={handleLinkClick} className='flex flex-row w-[100px] items-center cursor-pointer justify-between'>
                <img
              src={logo}
              alt=""
              className="w-[52.12px] h-[50px] sm:w-[40px] sm:h-[40px]"
            />
            <h1 className="uppercase text-spay-logo-text font-bold text-3xl sm:text-2xl">
              swop
            </h1>
            </Link>
            <h1 className="text-3xl mt-[40px] font-bold mb-4">Data Deletion</h1>
            <p className="mb-4">
                We understand that you may want to manage your data stored with Swop. Before proceeding, please take note of the following:
            </p>
            <ul className="list-disc pl-6 mb-4">
                <li>All your account information, including transaction history, payment details, and personal settings, will be permanently deleted.</li>
                <li>Once deleted, your data cannot be recovered. This action is irreversible.</li>
                <li>Deleting your data will also deactivate any active services or subscriptions associated with it.</li>
            </ul>
            <p className="mb-4">
                If you have any concerns about your data or would like to manage it, please contact our support team for assistance.
            </p>
        </div>
    );
}

export default DataDeletion;
